import request from '@/utils/request';
const path = 'tool/eventManager/deepBidType/jrtt';

/** 获取可用深度优化方式（体验版） */
export function getDeepBidTypeApi(params) {
  return request({
    url: `/${path}`,
    method: 'get',
    params,
  });
}
